import React from 'react';
import { ArrowRight } from 'lucide-react';
import DecorativeImage from './DecorativeImage';

const WhyChooseUsSection = ({ onOpenModal }) => (
  <section className="py-24 bg-white" data-testid="home-why-choose-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

        {/* Left — Content */}
        <div data-testid="why-choose-content">
          <p className="eyebrow mb-4">Why Choose Us</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter leading-tight mb-6">
            Don't Risk Losing Your Brand to Competitors
          </h2>
          <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-4">
            Every single day you operate without federal trademark protection, someone else can legally file a trademark of YOUR brand name and force you to rebrand entirely, causing you to lose years of goodwill overnight.
          </p>
          <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-8">
            Our experienced IP attorneys have a <strong className="text-[#111C16]">98% approval rate</strong> across a number of filings troughout the years. We file within 24-48 hours — because waiting could cost you everything.
          </p>
          <button
            onClick={() => onOpenModal?.('Why Choose Us')}
            className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-8 py-4 rounded-full transition-colors flex items-center gap-2"
            data-testid="why-choose-cta-button"
          >
            Register Your Trademark 
            <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </button>
        </div>

        {/* Right — Image */}
        <div data-testid="why-choose-image">
          <DecorativeImage
            src="/assets/img/faq.webp"
            alt="Professional signing legal document"
          />
        </div>

      </div>
    </div>
  </section>
);

export default WhyChooseUsSection;
